"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var Location = function Location(_ref) {
  var props = _ref.props;
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 11 13"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "20",
    strokeWidth: "1.0",
    d: "M9.612 5.546c0 3.404-4.376 6.321-4.376 6.321v0S.86 8.95.86 5.547a4.376 4.376 0 0 1 8.752 0z"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "20",
    strokeWidth: "1.0",
    d: "M5.239 6.997a1.459 1.459 0 1 0 0-2.917 1.459 1.459 0 0 0 0 2.917z"
  }))))));
};
var _default = exports.default = Location;